export default {
  "code[class*=\"language-\"]": {
    "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    "fontSize": "1em",
    "textAlign": "left",
    "whiteSpace": "pre",
    "wordSpacing": "normal",
    "wordBreak": "normal",
    "wordWrap": "normal",
    "lineHeight": "1.5",
    "MozTabSize": "4",
    "OTabSize": "4",
    "tabSize": "4",
    "WebkitHyphens": "none",
    "MozHyphens": "none",
    "msHyphens": "none",
    "hyphens": "none",
    "background": "black",
    "color": "white",
    "boxShadow": "-.3em 0 0 .3em black, .3em 0 0 .3em black"
  },
  "pre[class*=\"language-\"]": {
    "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    "fontSize": "1em",
    "textAlign": "left",
    "whiteSpace": "pre",
    "wordSpacing": "normal",
    "wordBreak": "normal",
    "wordWrap": "normal",
    "lineHeight": "1.5",
    "MozTabSize": "4",
    "OTabSize": "4",
    "tabSize": "4",
    "WebkitHyphens": "none",
    "MozHyphens": "none",
    "msHyphens": "none",
    "hyphens": "none",
    "padding": ".4em .8em",
    "margin": ".5em 0",
    "overflow": "auto",
    "background": "url('data:image/svg+xml;charset=utf-8,<svg%20version%3D\"1.1\"%20xmlns%3D\"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg\"%20width%3D\"100\"%20height%3D\"100\"%20fill%3D\"rgba(0%2C0%2C0%2C.2)\">%0D%0A<polygon%20points%3D\"0%2C50%2050%2C0%200%2C0\"%20%2F>%0D%0A<polygon%20points%3D\"0%2C100%2050%2C100%20100%2C50%20100%2C0\"%20%2F>%0D%0A<%2Fsvg>')",
    "backgroundSize": "1em 1em"
  },
  ":not(pre) > code[class*=\"language-\"]": {
    "padding": ".2em",
    "borderRadius": ".3em",
    "boxShadow": "none",
    "whiteSpace": "normal"
  },
  "comment": {
    "color": "#aaa"
  },
  "prolog": {
    "color": "#aaa"
  },
  "doctype": {
    "color": "#aaa"
  },
  "cdata": {
    "color": "#aaa"
  },
  "punctuation": {
    "color": "#999"
  },
  "namespace": {
    "Opacity": ".7"
  },
  "property": {
    "color": "#0cf"
  },
  "tag": {
    "color": "#0cf"
  },
  "boolean": {
    "color": "#0cf"
  },
  "number": {
    "color": "#0cf"
  },
  "constant": {
    "color": "#0cf"
  },
  "symbol": {
    "color": "#0cf"
  },
  "selector": {
    "color": "yellow"
  },
  "attr-name": {
    "color": "yellow"
  },
  "string": {
    "color": "yellow"
  },
  "char": {
    "color": "yellow"
  },
  "builtin": {
    "color": "yellow"
  },
  "operator": {
    "color": "yellowgreen"
  },
  "entity": {
    "color": "yellowgreen",
    "cursor": "help"
  },
  "url": {
    "color": "yellowgreen"
  },
  ".language-css .token.string": {
    "color": "yellowgreen"
  },
  "variable": {
    "color": "yellowgreen"
  },
  "inserted": {
    "color": "yellowgreen"
  },
  "atrule": {
    "color": "deeppink"
  },
  "attr-value": {
    "color": "deeppink"
  },
  "keyword": {
    "color": "deeppink"
  },
  "regex": {
    "color": "orange"
  },
  "important": {
    "color": "orange",
    "fontWeight": "bold"
  },
  "bold": {
    "fontWeight": "bold"
  },
  "italic": {
    "fontStyle": "italic"
  },
  "deleted": {
    "color": "red"
  },
  "pre.diff-highlight.diff-highlight > code .token.deleted:not(.prefix)": {
    "backgroundColor": "rgba(255, 0, 0, .3)",
    "display": "inline"
  },
  "pre > code.diff-highlight.diff-highlight .token.deleted:not(.prefix)": {
    "backgroundColor": "rgba(255, 0, 0, .3)",
    "display": "inline"
  },
  "pre.diff-highlight.diff-highlight > code .token.inserted:not(.prefix)": {
    "backgroundColor": "rgba(0, 255, 128, .3)",
    "display": "inline"
  },
  "pre > code.diff-highlight.diff-highlight .token.inserted:not(.prefix)": {
    "backgroundColor": "rgba(0, 255, 128, .3)",
    "display": "inline"
  }
};